import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/utils/tailwind.util';
const baseDropdownItemVariants = cva(cn('relative flex gap-3xs items-center h-[36px] w-full py-4xs px-2xs text-body-sm-medium text-ellipsis text-default cursor-pointer select-none focus:!shadow-none', 'rounded-2xs bg-default', 'hover:bg-neutral'), {
  variants: {
    checked: {
      true: 'bg-strong-alternative text-strong'
    },
    disabled: {
      true: 'pointer-events-none bg-default text-disabled'
    },
    invalid: {
      true: 'text-destructive'
    }
  },
  defaultVariants: {
    checked: false,
    disabled: false,
    invalid: false
  }
});
type DropdownItemProps = ComponentPropsWithoutRef<'div'> & {
  checked: boolean;
  disabled: boolean;
  invalid: boolean;
};

/**
 * Select, Dropdown 등 공통으로 사용하는 드롭다운 형태 안의 item UI
 */
export const BaseDropdownItemUI = forwardRef<HTMLDivElement, DropdownItemProps>((props, ref) => {
  const {
    className,
    checked,
    disabled,
    invalid,
    children,
    ...rest
  } = props;
  return <div ref={ref} className={baseDropdownItemVariants({
    checked,
    disabled,
    invalid,
    className
  })} {...rest}>
        {children}
      </div>;
});